module.exports = __webpack_public_path__ + "img/hamburger-icon.042b125b.svg";